"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bathtub = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const bathtub = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'bathtub-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M10.25 4.5C10.25 2.70507 11.7051 1.25 13.5 1.25C15.2949 1.25 16.75 2.70507 16.75 4.5V10.25H17C17.9665 10.25 18.75 11.0335 18.75 12V14.5C18.75 16.8472 16.8472 18.75 14.5 18.75H7C3.82436 18.75 1.25 16.1756 1.25 13V12C1.25 11.0335 2.0335 10.25 3 10.25H15.25V4.5C15.25 3.5335 14.4665 2.75 13.5 2.75C12.5335 2.75 11.75 3.5335 11.75 4.5V5.09451C13.0439 5.42755 14 6.60212 14 8H8C8 6.60212 8.95608 5.42755 10.25 5.09451V4.5ZM3 11.75H17C17.1381 11.75 17.25 11.8619 17.25 12V14.5C17.25 16.0188 16.0188 17.25 14.5 17.25H7C4.65279 17.25 2.75 15.3472 2.75 13V12C2.75 11.8619 2.86193 11.75 3 11.75Z', fill: '#4B5563' })));
};
exports.bathtub = bathtub;
